(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('entite-parente', {
            parent: 'entity',
            url: '/entite-parente?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.entiteParente.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/entite-parente/entite-parentes.html',
                    controller: 'EntiteParenteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entiteParente');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('entite-parente-detail', {
            parent: 'entity',
            url: '/entite-parente/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.entiteParente.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/entite-parente/entite-parente-detail.html',
                    controller: 'EntiteParenteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entiteParente');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EntiteParente', function($stateParams, EntiteParente) {
                    return EntiteParente.get({id : $stateParams.id});
                }]
            }
        })
        .state('entite-parente.new', {
            parent: 'entite-parente',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/entite-parente/entite-parente-dialog.html',
                    controller: 'EntiteParenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nom: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('entite-parente', null, { reload: true });
                }, function() {
                    $state.go('entite-parente');
                });
            }]
        })
        .state('entite-parente.edit', {
            parent: 'entite-parente',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/entite-parente/entite-parente-dialog.html',
                    controller: 'EntiteParenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EntiteParente', function(EntiteParente) {
                            return EntiteParente.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('entite-parente', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('entite-parente.delete', {
            parent: 'entite-parente',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/entite-parente/entite-parente-delete-dialog.html',
                    controller: 'EntiteParenteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EntiteParente', function(EntiteParente) {
                            return EntiteParente.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('entite-parente', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
